import { render, staticRenderFns } from "./AlertsList.vue?vue&type=template&id=27a68cb5&"
import script from "./AlertsList.vue?vue&type=script&lang=js&"
export * from "./AlertsList.vue?vue&type=script&lang=js&"
import style0 from "./AlertsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports